<template>
  <div
    class="modal"
    id="wnmProductConfiguratorRequestOfferDialog"
    aria-labelledby="wnmProductConfiguratorRequestOfferDialog"
    aria-hidden="true"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content p-0 overflow-hidden">
        <div :class="{'bg': !hasBeenSent}"></div>
        <div class="modal-body px-3 py-5">
          <button type="button" class="close text-primary" data-dismiss="modal" aria-label="Close" @click="onClose">
            <span aria-hidden="true">&times;</span>
          </button>

          <template v-if="!hasBeenSent">
            <div class="row">
              <div class="col-9">
                <h2>Mit diesem Formular senden Sie Ihre Konfiguration an einen unserer Experten. Dieser meldet sich dann innerhalb kurzer Zeit mit einem unverbindlichen Angebot bei Ihnen.</h2>
              </div>
            </div>
            <form @submit.prevent="sendRequestOfferMail">
              <div class="row">
                <div class="col-6 d-flex flex-column">
                  <div class="form-group">
                    <input
                      v-model="email"
                      type="email"
                      placeholder="E-Mail-Adresse*"
                      class="form-control form-control-sm"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      v-model="name"
                      type="text"
                      placeholder="Name*"
                      class="form-control form-control-sm"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      v-model="company"
                      type="text"
                      placeholder="Firma"
                      class="form-control form-control-sm"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      v-model="phoneNumber"
                      type="tel"
                      placeholder="Telefon"
                      class="form-control form-control-sm"
                    />
                  </div>
                  <div class="form-group">
                    <textarea
                      v-model="comment"
                      placeholder="Ihre Nachricht an uns."
                      aria-placeholder="Ihre Nachricht an uns."
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
                <div class="col-4">
                  <div class="mb-3">
                    <span class="font-size-lg">Wenden Sie sich bei Fragen auch gerne telefonisch an unsere zertifizierten Experten:</span>
                  </div>
                  <div>
                    <a href="tel:+492234806902598">
                      <i class="fas fa-phone icons"></i>
                      <span class="ml-1">+49 2234 2196500</span>
                    </a>
                  </div>
                  <div>
                    <a href="mailto:nh@serverhero.de">
                      <i class="fas fa-envelope icons"></i>
                      <span class="ml-1">info@serverhero.de</span>
                    </a>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="datenschutz-field-subgroup">
                  <span class="datenschutz-field-option d-flex">
                    <input type="checkbox"
                           v-model="confirmBox"
                           name="form_fields[field_3]"
                           id="form-field-field_3"
                           class="datenschutz-field datenschutz-size-md  datenschutz-acceptance-field"
                           required="required"
                           aria-required="true">
                    <label for="form-field-field_3" style="margin-left: 10px;margin-top: -4px;">
                      <span>Ich nehme die <a href="/Datenschutz" target="_blank">Datenschutzerklärung</a> zur Kenntnis und bin mit der Verarbeitung meiner Daten einverstanden.</span>
                    </label>
                  </span>
                  </div>
                </div>
              </div>

              <div class="row mb-7">
                <div class="col-3 d-flex align-items-center justify-content-center">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded request-offer-send-button"
                  >Angebot anfragen
                  </button>
                </div>
              </div>
            </form>
          </template>
          <template v-if="hasBeenSent">
            <div class="d-flex flex-column align-items-center">
              <RequestOfferSent/>
              <span>Vielen Dank für Ihre Anfrage.</span>
              <span class="text-center">Sie erhalten in Kürze eine E-Mail mit Ihrer Konfiguration. Einer unserer zertifizierten Experten meldet sich <span
                class="font-weight-bold">innerhalb von 24h</span> mit einem <span class="font-weight-bold">individuellen Angebot</span> bei Ihnen.</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, onMounted, ref} from "vue";
import RequestOfferSent from "components/Icons/RequestOfferSent";
import Phone from "components/Icons/Phone";
import Envelope from "components/Icons/Envelope";
import {useStore} from "vuex";
import {call} from "io";

export default {
  name: "RequestOfferDialog",
  components: {Envelope, Phone, RequestOfferSent},
  setup() {
    const store = useStore();

    const requestOfferDialogEl = ref();

    const hasBeenSent = ref(false);
    const name = ref('');
    const phoneNumber = ref('');
    const email = ref('');
    const company = ref('');
    const comment = ref('');

    const confirmBox = ref(false);
    onMounted(() => {
      $('#wnmProductConfiguratorRequestOfferDialog').on('hidden.bs.modal', () => {
        hasBeenSent.value = false;

        name.value = '';
        phoneNumber.value = '';
        email.value = '';
        company.value = '';
        comment.value = '';
      });
    });

    return {
      requestOfferDialogEl,

      hasBeenSent,
      name,
      phoneNumber,
      email,
      company,
      comment,
      confirmBox,

      async sendRequestOfferMail() {
        if(confirmBox.value) {
          const offerDetails = computed(() => store.getters.getOfferDetails);

          await call('wnm.productConfigurator.sendOfferMail', {
            sendOfferData: {
              name: name.value,
              phoneNumber: phoneNumber.value,
              email: email.value,
              company: company.value,
              comment: comment.value,
            },
            ...offerDetails.value,
          });
          hasBeenSent.value = true;
        }
      },

      onClose() {
        hasBeenSent.value = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.close {
  position: absolute;
  right: 5px;
  top: 5px;
}

.request-offer-send-button {
  border-radius: 24px;
}

.bg {
  position: absolute;

  bottom: 0;
  top: 40%;
  right: -10%;
  left: -25%;

  background: url('assets/requestOfferDialogBackground.svg');
  background-size: cover;
  background-repeat: no-repeat;
}

.icons {
  color: #00a2f8;
}
</style>